import createReactClass from 'create-react-class';
import BaseMixin from './BaseMixin';

const BooleanTerminal = createReactClass({
  displayName: 'BooleanTerminal',
  mixins: [BaseMixin],

  render: function() {
    return (
      this.renderTerminalName()
    );
  }
});

export default BooleanTerminal;
